import React from "react";
import { useSettings } from "../components/SettingsContext";
import { Helmet } from "react-helmet";

export default function TermsAndConditions() {
  const { settings } = useSettings();

  return (
    <>
    <Helmet>
      <title>Terms and Conditions</title>
    </Helmet>
    <div>
      <section className="page-title-area sky-blue-bg pt-160 pb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6">
              <div className="page-title-wrapper text-center">
                <h4 className="styled-text theme-color mb-30">Our Legal Agreement</h4>
                <h5 className="h1 page-title">Terms & Conditions</h5>
                <p className="mb-4">
                  Understand your rights and responsibilities when using our services.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="terms-content">
                <div dangerouslySetInnerHTML={{ __html: settings?.terms || "Loading..." }} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
}
